import type { CheckoutEvidence } from '../../models/insuranceIndication'
import { checkoutEvidenceRows } from './checkoutEvidenceRows'

export interface CheckoutEvidenceSummaryProps {
  evidence: CheckoutEvidence
}

/** Who checked out, from where and when — read on the sidebar without opening anything. */
export function CheckoutEvidenceSummary({ evidence }: CheckoutEvidenceSummaryProps) {
  const rows = checkoutEvidenceRows(evidence)
  if (rows.length === 0) return null

  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-sm">
      {rows.map((row) => (
        <div key={row.label} className="contents">
          <dt className="text-muted-foreground whitespace-nowrap">{row.label}</dt>
          <dd className="break-all">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
